// extracted by mini-css-extract-plugin
export var black = "subtitle-module--black--0c589";
export var fadeInAnimation = "subtitle-module--fadeInAnimation--45498";
export var lg = "subtitle-module--lg--42e0c";
export var md = "subtitle-module--md--77f84";
export var sm = "subtitle-module--sm--775af";
export var subtitle = "subtitle-module--subtitle--043b5";
export var white = "subtitle-module--white--092a4";
export var xsm = "subtitle-module--xsm--a0d7c";